import React, { Component } from 'react';
import { Accordion, Divider, Grid, Icon } from 'semantic-ui-react';

import { getQc } from '../../services/AdServiceManager';
import { getErrorReportAd } from '../../utils/ad.common';
import AdPreview from '../../components/common/AdPreview';

class ErrorReportDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      processing: true,
      token: props.getFbToken(),
    };
  }
  componentDidMount() {
    this.getAllData();
  }
  getAllData = async () => {
    const { errorReport } = this.props;
    const ad = await getErrorReportAd(errorReport.ad_id, this.state.token);
    const adQc = await getQc(errorReport.ad_id);
    this.setState({
      ad,
      adQc,
      processing: false,
    });
  }
  getLoggedBy = () => {
    const { errorReport } = this.props;
    return (errorReport.logged_by_fullname && errorReport.logged_by_fullname !== '') ? errorReport.logged_by_fullname : errorReport.logged_by_username;
  }
  getQCApproved = () => {
    const { adQc } = this.state;
    let qcUsers = '';
    if (adQc) {
      if (adQc.qc1) {
        qcUsers = adQc.qc1Fullname === '' ? adQc.qc1Username : adQc.qc1Fullname;
      }
      if (adQc.qc2) {
        qcUsers = `${qcUsers}, ${adQc.qc2Fullname === '' ? adQc.qc2Username : adQc.qc2Fullname}`;
      }
    }
    return qcUsers === '' ? 'NONE' : qcUsers;
  }
  renderAccordionTitle = (ad) => {
    const adAccount = this.props.accounts.find(a => a.value === ad.ad.account_id);
    if (adAccount) {
      let friendlyName = ad.adFriendlyName;
      friendlyName = friendlyName.replace(adAccount.text, '');
      friendlyName = friendlyName.replace(adAccount.text.replace(/ /g, ''), '');
      return `${adAccount.text} - ${friendlyName}`;
    }
    return ad.adFriendlyName;
  }
  render() {
    const { errorReport } = this.props;
    const { processing, ad } = this.state;
    if (processing) {
      return null;
    }
    return (
      <div>
        <Accordion.Title active={this.state.isOpen || this.props.expandAll} onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>
          <Icon name="dropdown" /> {this.renderAccordionTitle(ad)}
        </Accordion.Title>
        <Accordion.Content active={this.state.isOpen || this.props.expandAll}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <AdPreview
                  title={ad.isCollection || ad.isCanvas ? 'Mobile Ad Preview' : 'Desktop Ad Preview'}
                  maxWidthDiv={ad.isCollection || ad.isCanvas ? 320 : 720}
                  maxHeight={ad.isCollection || ad.isCanvas ? 620 : 765}
                  offsetVertical={ad.isCollection || ad.isCanvas ? 900 : 1500}
                  iframe_url={ad.isCollection || ad.isCanvas ? ad.preview.mobile : ad.preview.desktop}
                />
              </Grid.Column>
              <Grid.Column width={8}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <strong>External</strong>
                      <div>{errorReport.is_external ? 'Yes' : 'No'}</div>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <strong>Logged By </strong>
                      <div>{this.getLoggedBy()}</div>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <strong>QC Approved By</strong>
                      <div>{this.getQCApproved()}</div>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <strong>Team Responsible</strong>
                      <div>{errorReport.team_responsible}</div>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <strong>Severity</strong>
                      <div>{errorReport.severity}</div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Divider />
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <strong>Issue</strong>
                      <div>{errorReport.issue}</div>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <strong>Reason</strong>
                      <div>{errorReport.reason}</div>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <strong>Suggested Changes</strong>
                      <div>{errorReport.suggested_changes}</div>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <strong>Outcome</strong>
                      <div>{errorReport.outcome}</div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>
      </div>
    );
  }
}

export default ErrorReportDetail;



// WEBPACK FOOTER //
// ./src/screens/AdErrorReport/ErrorReportDetail.js